import { GetIssuedPremiumsParams, reportsService } from '@/services';
import { useQuery } from '@tanstack/react-query';

/**
 * Lista paginada de prêmios emitidos + cards. Só dispara quando o período
 * (obrigatório) está preenchido — evita chamadas 400 antes do usuário escolher.
 */
export function useIssuedPremiums(params: GetIssuedPremiumsParams = {}) {
  const enabled = Boolean(params.issueDateFrom && params.issueDateTo);

  return useQuery({
    queryKey: ['issued-premiums', params],
    enabled,
    queryFn: async () => {
      const response = await reportsService.listIssuedPremiums(params);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Não foi possível carregar os prêmios emitidos.');
      }
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}
